<template>
    <div id="basic-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('settings.Edit_user_manual_type') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="row">
              <div class="col-12">
                  <div class="input-group input-group-static null">
                      <label>{{ $t('settings.Name') }}</label>
                      <input v-model="state.name" type="text" class="form-control form-control-default" placeholder="Name">
                      <span v-if="v$.name.$error" class="text-sm text-danger">
                              {{ v$.name.$errors[0].$message }}
                      </span>
                  </div>
              </div>
          </div>
          <div class="row mt-4">
              <div class="col-4">
                  <div class="input-group input-group-static null">
                      <label class="d-block mb-1" style="width: inherit;">{{ $t('settings.IsGlobal') }}</label>
                      <div class="d-block mt-1">
                      <material-switch v-model="state.isGlobal" id="isGlobal" name="isGlobal" />
                      </div>
                  </div>
              </div>
          </div>                             
        </div>        
        <div class="col-12 col-sm-12 mt-6">                                
          <input type="hidden" v-model="state.id" class="form-control">          
          <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
          <button v-on:click="updateUserManualType" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>                                                    
        </div>        
      </div>
    </div>    
  </template>
  
  <script>
  import axios from 'axios'
  import useValidate from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import MaterialSwitch from "@/components/MaterialSwitch.vue";

  export default {
    name: "UserManualTypeDetail",
    setup() {
        const { t } = useI18n()

        const state = reactive ({            
            usermanualtype: [],
            id: '',
            name: '',
            isGlobal: false
        })

        const rules = computed(() => {
            return {
              name: { required: helpers.withMessage(t('common.Required'), required) },                                
            }
        })  
        
        const v$ = useValidate(rules, state)

        return {
            state,
            v$,
        }
    },    
    components: {  
      MaterialSwitch   
    },
    data() {
      return {        
        gets: [],        
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;            
      await this.fetchUserManualTypeData(this.$route.params.id);         
    },
    methods: { 
     
      async fetchUserManualTypeData(userManualTypeId) {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`UserManualType/${userManualTypeId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.usermanualtype = this.gets.data;
                this.state.id = this.state.usermanualtype.id;
                this.state.name = this.state.usermanualtype.name;
                this.state.isGlobal = this.state.usermanualtype.isGlobal;
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          this.$showError('errors.Contact_system_admin');
        } finally {        
          this.$store.commit('setShowLoading', false);
        }
      },

      async updateUserManualType() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.v$.$validate();                
            console.log(this.v$.$error);

            if(!this.v$.$error) {
                const response = await axios.put('UserManualType/update', {
                  "id": this.state.id,
                  "name": this.state.name,
                  "isGlobal": this.state.isGlobal
                });
                this.gets = response.data;

                if (this.gets.success) {
                  this.$showSuccess('errors.Success_user_manual_type_updated_successfully');                      
                  this.$router.push('/settings');
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }                
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        this.$store.commit('setShowLoading', false);
      },
    }
  };
</script>  
<style>
.choices {
  margin-bottom: 0px !important;
}
</style>